import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {TrackDetailModel} from '../models/track-detail.model';
import {environment} from "../../environments/environment";

@Injectable()
export class TrackDetailDataSource {

  constructor(
    private http: HttpClient
  ) { }

  getTrackDetail(sessionKey: string): Observable<TrackDetailModel> {
    return this.http.get<TrackDetailModel>(environment.backendApi + 'api/TrackLogs/GetTrackDetail/' + sessionKey);
  }
}
